import { render } from "./Access.vue?vue&type=template&id=8b0d0a4a&scoped=true&lang=pug"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=8b0d0a4a&lang=scss&scoped=true"
import "./Access.vue?vue&type=style&index=1&id=8b0d0a4a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0d0a4a"]])

export default __exports__